export const validatePassword = (label: string) => (value: string) =>
  value && /^(?=.*[\d])(?=.*[A-Z])(?=.*[a-z])(?=.*[\W|_])[\w!@#$%^&*\\/{|}?.,<>~'";`:[\]()-_=+]{8,30}$/.test(value)
    ? undefined
    : label;
